import { ILead, ILeadReq } from "../../models/BaseModel";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { BaseReq } from "./requirements/BaseReq";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { confirmDialog } from "primereact/confirmdialog";
import { Room } from "./requirements/Room";
import { Transport } from "./requirements/Transport";
import { ActivityReq } from "./requirements/ActivityReq";
import { ItineraryReq } from "./requirements/ItineraryReq";

interface Iprops {
    leadId: number
    singleData: ILead,
    toast: any
}
export interface IActivityType { activityTypeId: number, activityTypeName: string, activityTypeIcon: string, activitiesCount: number }

export const LeadRequirement = (props: Iprops) => {
    const [tableData, setTableData] = useState<{ data: ILeadReq[], loading: boolean }>({ data: [], loading: false });
    const [baseReq, setBaseReq] = useState<{ req: ILeadReq, type: 'none' | 'baseReq' | 'accomodation' | 'food' | 'transport' | 'itinerary' }>({ req: { leadId: props.leadId }, type: 'none' });
    const [aReq, setAReq] = useState<{ activityType: IActivityType, req: ILeadReq, open: boolean }>({ activityType: { activityTypeId: 0, activityTypeName: '', activityTypeIcon: '', activitiesCount: 0 }, req: { leadId: props.leadId }, open: false });
    function hideAReq() {
        setAReq({ activityType: { activityTypeId: 0, activityTypeName: '', activityTypeIcon: '', activitiesCount: 0 }, req: { leadId: props.leadId }, open: false });
    }

    const loadLeadRequirement = async (leadId: number) => {
        setTableData(prev => ({ ...prev, loading: true }));
        const response = await Fetch(`leadreq/${leadId}`, "GET", null, null, props.toast);
        if (response) {
            const req: ILeadReq[] = await response.json();
            setTableData({ data: req, loading: false });
        } else {
            setTableData(prev => ({ ...prev, loading: false }));
        }
    }

    useEffect(() => {
        if (props.leadId) loadLeadRequirement(props.leadId);
    }, [props.leadId]);

    const hideBaseReq = () => {
        setBaseReq({ req: { leadId: props.leadId }, type: 'none' });
    }

    const onNewBaseReq = () => {
        const lastcheckout = tableData.data?.at(-1)?.checkout;
        const newcheckin = lastcheckout ? new Date(lastcheckout) : undefined;
        setBaseReq({
            req:
            {
                leadId: props.leadId,
                checkin: newcheckin,
            },
            type: 'baseReq'
        });
    }

    const hidePopupAndReloadTable = () => {
        if (props.leadId) loadLeadRequirement(props.leadId);
        hideBaseReq();
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4"
            style={{
                background: "linear-gradient(90deg, #def7e3ff, #ecf4edff)",
                borderBottom: "2px solid #95e99c",
                borderRadius: "8px 8px 0 0",
                padding: "0.6rem 1rem",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)"
            }}
        >
            <div className="flex gap-4 w-full">
                <Button style={{ width: '180px' }} loading={tableData.loading} onClick={onNewBaseReq} label="Add Package" icon="pi pi-plus" type="button" className="p-button-sm p-button-rounded p-button-success mb-2" />
                <div className="w-full flex align-items-center justify-content-center">
                    <h5 style={{ margin: 0, color: "#00796b" }}>
                        Requirements - Package & Checkin : ({props.singleData.contactName} | {props.singleData.contactContact})
                    </h5>
                </div>
            </div>
            <div className="flex gap-4">

            </div>
        </div>
    );

    const checkInBody = (r: ILeadReq) => {
        return format(new Date(r.checkin ?? ''), 'dd/MM/yyyy hh:mm a');
    }
    const checkOutBody = (r: ILeadReq) => {
        return format(new Date(r.checkout ?? ''), 'dd/MM/yyyy');
    }
    const destinationBody = (r: ILeadReq) => {
        return `${r.cityName}, ${r.stateName}, ${r.countryName}`;
    }
    const actionBodyTemplate = (r: ILeadReq) => {
        const hasrooms = r.rooms && r.rooms.length > 0;
        const hastransport = r.pickAndDrops && r.pickAndDrops.length > 0;
        const hasItinerary = r.itinerary && r.itinerary.length > 0;
        return (
            <div className="actions">
                {!(hasrooms || hastransport || hasItinerary) && <Button icon="pi pi-pencil" tooltip="Edit Package" tooltipOptions={{ position: 'top' }} className={`p-button-sm p-button-success p-button-text p-0`} onClick={() => setBaseReq({ req: r, type: 'baseReq' })} />}
                <Button icon="pi pi-building" tooltip="Accommodation" tooltipOptions={{ position: 'top' }} className={`p-button-sm ${hasrooms ? 'p-button-success' : 'p-button-warning'} p-button-text p-0`} onClick={() => { setBaseReq({ req: r, type: 'accomodation' }) }} />
                <Button icon="pi pi-car" tooltip="Transport" tooltipOptions={{ position: 'top' }} className={`p-button-sm ${hastransport ? 'p-button-success' : 'p-button-warning'} p-button-text p-0`} onClick={() => { setBaseReq({ req: r, type: 'transport' }) }} />
                <Button icon="pi pi-list" tooltip="Itinerary" tooltipOptions={{ position: 'top' }} className={`p-button-sm ${hasItinerary ? 'p-button-success' : 'p-button-warning'} p-button-text p-0`} onClick={() => { setBaseReq({ req: r, type: 'itinerary' }) }} />
                {
                    r.activityTypes && r.activityTypes.length > 0 &&
                    r.activityTypes.map((at) => (
                        <Button key={at.activityTypeId} icon={at.activityTypeIcon} tooltip={at.activityTypeName} tooltipOptions={{ position: 'top' }} className='p-button-sm p-button-success p-button-text p-0' onClick={() => { setAReq({ activityType: at, req: r, open: true }) }} />
                    ))
                }
                <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className='p-button-sm p-button-danger p-button-text p-0' onClick={() => { confirmDelete(r) }} />
            </div>
        );
    };

    const Remove = async (r: ILeadReq) => {
        const response = await Fetch(`leadreq/${r.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Requirement Deleted", life: 3000 });
            if (props.leadId) loadLeadRequirement(props.leadId)
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (r: ILeadReq) => {
        confirmDialog({
            message: `Are you sure you want to delete "${r.cityName}|${r.stateName}|${r.countryName}-${r.packageName}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(r),
            reject: () => rejectFunc()
        });
    }

    const roomsBody = (r: ILeadReq) => {
        if (!r.rooms || r.rooms.length === 0) return <span>--</span>;
        return (
            <div>
                {r.rooms.map((room, index) => (
                    <div key={index}>
                        {room.count} x {room.roomTypeName}
                        {room.mattress > 0 && (
                            <span>
                                {" "}+ {room.mattress}{" "}
                                {room.mattress > 1 ? "Mattresses" : "Mattress"}
                            </span>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    const transportBody = (r: ILeadReq) => {
        if (!r.pickAndDrops || r.pickAndDrops.length === 0) return <span>--</span>;
        return (
            <div>
                {r.pickAndDrops.map((pd, index) => (
                    <div key={index}>
                        {pd.noOfPeople} passengers, {pd.pickupLocationName}
                        ({(pd.vehicles?.map((v) => `${v.count} x ${v.vehicleTypeName}`))?.join(", ")})
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div>
            <div
                style={{
                    backgroundColor: "#f6fdf8",
                    border: "1px solid #cce3d0",
                    borderRadius: "14px",
                    padding: "1rem",
                    margin: "1rem 0.5rem",
                    boxShadow: "0 3px 10px rgba(0, 128, 0, 0.08)",
                    transition: "all 0.3s ease-in-out",
                }}
                className="expand-container"
            >
                <DataTable className="grey-teal-table" value={tableData.data} loading={tableData.loading}
                    header={header} style={{
                        background: "white",
                        borderRadius: "10px",
                        overflow: "hidden",
                    }}
                    size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh"
                    rowClassName={(r: ILeadReq) => (r.id === baseReq.req.id ? 'bg-orange-100' : '')}>
                    <Column field="checkin" header="CheckIn" body={checkInBody} />
                    <Column field="checkout" header="CheckOut" body={checkOutBody} />
                    <Column field="cityName" header="Destination" body={destinationBody} />
                    <Column field="packageName" header="Package" />
                    <Column field="hotelName" header="Hotel" />
                    <Column field="noOfAdults" header="Adults" />
                    <Column field="noOfChildren" header="Children" />
                    <Column field="rooms" header="Accommodation" body={roomsBody} />
                    <Column field="transport" header="Transport" body={transportBody} />
                    <Column body={actionBodyTemplate} />
                </DataTable>
            </div>
            <BaseReq open={baseReq.type === 'baseReq'} onHide={hideBaseReq} onSuccess={hidePopupAndReloadTable} req={{ ...baseReq.req, checkin: baseReq.req.checkin ? new Date(baseReq.req.checkin) : undefined, checkout: baseReq.req.checkout ? new Date(baseReq.req.checkout) : undefined }} toast={props.toast} />
            <Room open={baseReq.type === 'accomodation'} onHide={hideBaseReq} onSuccess={hidePopupAndReloadTable} req={{ ...baseReq.req, checkin: baseReq.req.checkin ? new Date(baseReq.req.checkin) : undefined, checkout: baseReq.req.checkout ? new Date(baseReq.req.checkout) : undefined }} toast={props.toast} />
            <Transport open={baseReq.type === 'transport'} onHide={hideBaseReq} onSuccess={hidePopupAndReloadTable} req={{ ...baseReq.req, checkin: baseReq.req.checkin ? new Date(baseReq.req.checkin) : undefined, checkout: baseReq.req.checkout ? new Date(baseReq.req.checkout) : undefined }} toast={props.toast} />
            <ItineraryReq open={baseReq.type === 'itinerary'} onHide={hideBaseReq} onSuccess={hidePopupAndReloadTable} req={{ ...baseReq.req, checkin: baseReq.req.checkin ? new Date(baseReq.req.checkin) : undefined, checkout: baseReq.req.checkout ? new Date(baseReq.req.checkout) : undefined }} toast={props.toast} />
            <ActivityReq open={aReq.open} activityType={aReq.activityType} onHide={hideAReq} onSuccess={hideAReq} req={{ ...aReq.req, checkin: aReq.req.checkin ? new Date(aReq.req.checkin) : undefined, checkout: aReq.req.checkout ? new Date(aReq.req.checkout) : undefined }} toast={props.toast} />
        </div>
    );
}
